<div
  class="flex flex-col custom-table gap-1 card"
  [ngClass]="{ 'p-2': isAssetDetailsPage }"
  *ngIf="currentEventsData.items.length || !isAssetDetailsPage"
>
  <h3 class="card-title">
    {{ 'ServicingService::CurrentEvents' | abpLocalization }}
  </h3>
  <ngx-datatable
    [rows]="currentEventsData.items"
    [count]="currentEventsData.totalCount"
    [list]="list"
    default
  >
    <ngx-datatable-column
      [sortable]="false"
      class="bg-gray-30"
      name="{{ 'ServicingService::EventType' | abpLocalization }}"
      prop="inspectionTypeName"
      [width]="100"
    >
      <ng-template let-row="row" ngx-datatable-cell-template>
        {{ row?.inspectionTypeName ?? '' }}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
      name="{{ 'ServicingService::Date' | abpLocalization }}"
      prop="doneOn"
      [width]="100"
    >
      <ng-template let-row="row" ngx-datatable-cell-template>
        {{ row?.doneOn | date }}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
      [name]="
        ('ServicingService::DueOn' | abpLocalization) +
        ' : ' +
        ('ServicingService::Date' | abpLocalization)
      "
      prop="dueOn"
      [width]="100"
    >
      <ng-template let-row="row" ngx-datatable-cell-template>
        {{
          row?.kmLimit || row?.hourLimit || row?.recurrence === RecurrenceType.Adhoc
            ? '-'
            : (row?.dueOn | date)
        }}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
      [name]="
        ('ServicingService::DueOn' | abpLocalization) +
        ' : ' +
        ('ServicingService::Km' | abpLocalization)
      "
      prop="dueOn"
      [sortable]="false"
      [width]="100"
    >
      <ng-template let-row="row" ngx-datatable-cell-template>
        {{ row?.kmLimit || '-' }}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
      [name]="
        ('ServicingService::DueOn' | abpLocalization) +
        ' : ' +
        ('RegisterService::Hours' | abpLocalization)
      "
      prop="dueOn"
      [sortable]="false"
      [width]="100"
    >
      <ng-template let-row="row" ngx-datatable-cell-template>
        {{ row?.hourLimit || '-' }}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
      [sortable]="false"
      name="{{ 'ServicingService::Status' | abpLocalization }}"
      prop="inspectionStatusName"
      [width]="100"
    >
      <ng-template let-row="row" ngx-datatable-cell-template>
        {{ row?.inspectionStatusName ?? '' }}
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [maxWidth]="175" [width]="175" [sortable]="false">
      <ng-template let-row="row" let-i="rowIndex" ngx-datatable-cell-template>
        <div class="flex w-full items-center justify-end">
          <div class="btn-group">
            <button type="button" class="btn btn-light btn-sm" (click)="onView(row)">
              <i class="fa fa-eye me-1" aria-hidden="true"></i>
            </button>
            <div class="btn-group" role="group" container="body" ngbDropdown class="d-inline-block">
              <button
                type="button"
                class="btn btn-light btn-sm dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                ngbDropdownToggle
              >
                <i class="fa fa-ellipsis-v me-1" aria-hidden="true"></i>
              </button>
              <div ngbDropdownMenu>
                <button
                  type="button"
                  ngbDropdownItem
                  *abpPermission="'ServicingService.Events'"
                  (click)="onGetReport(row)"
                >
                  {{ 'CertReportService::GetReport' | abpLocalization }}
                </button>
                <button
                  type="button"
                  ngbDropdownItem
                  *abpPermission="'ServicingService.Events.Create'"
                  (click)="onRepeat(row)"
                >
                  {{ 'AbpUi::Repeat' | abpLocalization }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ngx-datatable-column>
  </ngx-datatable>
</div>
